import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Copy, ExternalLink } from "lucide-react";
import { copyToClipboard } from "@/lib/utils";
import { useToast } from "@/hooks/use-toast";

type AgentShareLinkTabProps = {
  agentUrl: string;
  agentPublicId: string;
};

const AgentShareLinkTab: React.FC<AgentShareLinkTabProps> = ({
  agentUrl,
  agentPublicId,
}) => {
  const { toast } = useToast();
  const [shareableLink, setShareableLink] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      setShareableLink(
        `${window.location.origin}/${encodeURIComponent(agentUrl)}/${agentPublicId}`,
      );
    }
  }, [agentPublicId, agentUrl]);

  const handleCopyLink = () => {
    copyToClipboard(
      shareableLink,
      "The shareable link has been copied to your clipboard.",
    );
  };
  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <h3 className="text-sm font-medium text-gray-900">Share Link</h3>
        <p className="text-sm text-gray-600">
          Share this link with others to let them chat with your agent.
        </p>
      </div>

      <div className="space-y-3">
        <div className="flex items-center gap-2">
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 flex-1 min-w-0">
            <div
              className="text-sm text-gray-800 truncate"
              title={shareableLink}
            >
              {shareableLink}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={handleCopyLink}
            className="flex-1"
          >
            <Copy className="h-4 w-4 mr-2" />
            Copy Link
          </Button>
          <Button variant="outline" size="sm" asChild className="flex-1">
            <a href={shareableLink} target="_blank" rel="noopener noreferrer">
              <ExternalLink className="h-4 w-4 mr-2" />
              Open Link
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
};
export default AgentShareLinkTab;
